import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AngularFireAuth } from 'angularfire2/auth';
import { User as FirebaseUser } from 'firebase';

import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/first';

@Injectable()
export class AuthGuardService implements CanActivate, CanActivateChild {

  constructor(
    private router: Router,
    private afAuth: AngularFireAuth
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return Observable.create((observer: Observer<boolean>) => {
      this.afAuth.authState
        .first()
        .subscribe((firebaseUser: FirebaseUser | null) => {
          const isLoggedIn = !!firebaseUser;

          if (!isLoggedIn) {
            this.router.navigateByUrl('/login');
          }

          observer.next(isLoggedIn);
          observer.complete();
        });
    });
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(childRoute, state);
  }
}



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/services/auth-guard.service.ts